import AsyncStorage from "@react-native-community/async-storage";
import React, { useEffect, useState } from "react";
import {
    Dimensions,
    Image,
    ImageBackground,
    ScrollView,
    Text,
    TouchableOpacity,
    View,
} from "react-native";
import Menu from "../menu";
import style from "../../Styles/perfil";
import XarxesSocials from "../PopUps/XarxesSocials";
import getPointsItinerari from "../../Functions/getPointsItinerari";
import { getRecursText, getRecursURL } from "../../Functions/getRecurs";

function Perfil(RouterData) {
    const { idioma, itineraris, projecte, recursos } = RouterData.route.params;

    const [nom, setNom] = useState("");
    const [punts, setPunts] = useState(0);
    const [token, setToken] = useState("");
    const [statsItineraris, setStatsItineraris] = useState([]);

    useEffect(() => {
        getPointsItinerari(itineraris)
            .then((data) => {
                setStatsItineraris(data);
            })
            .catch((err) => {
                console.log(err);
            });

        AsyncStorage.getItem("nom").then((nom) => {
            if (nom) {
                setNom(nom);
            }
        });
        AsyncStorage.getItem("puntsTotals").then((punts) => {
            if (punts) {
                setPunts(punts);
            }
        });
        AsyncStorage.getItem("token").then((token) => {
            if (token) {
                setToken(token);
            }
        });
    }, []);

    const navigateImatges = (itinerari) => {
        let statsPressedItinerari = statsItineraris.itineraris.find(
            (e) => e.itinerari == itinerari.id,
        );
        RouterData.navigation.navigate("ImatgesItinerari", {
            ...RouterData.route.params,
            perfilImatges: statsPressedItinerari,
        });
    };

    const renderItineraris = () => {
        let items = [];
        itineraris.map((itinerari, index) => {
            let color = "red";
            let textColor = "white"; // TODO personalitzat

            if (statsItineraris.itineraris) {
                if (statsItineraris.itineraris[index]?.estat === "finalitzat") {
                    color = projecte.colorPrincipal1;
                    textColor = "black"; // TODO personalitzat
                } else if (statsItineraris.itineraris[index]?.estat === "comencat") {
                    color = projecte.colorPrincipal2;
                    textColor = "black"; // TODO personalitzat
                }
            }

            items.push(
                <TouchableOpacity
                    style={style.botoItinerari}
                    key={index}
                    onPress={() => {
                        navigateImatges(itinerari);
                    }}
                >
                    <View style={[style.itinerariContainer, { backgroundColor: color }]}>
                        <Text style={{ fontSize: 14, fontWeight: "bold", padding: 5 }}>
                            <Text style={[style.itinerariText, { color: textColor }]}>
                                {itinerari.Nom ? itinerari.Nom.toUpperCase() : null}
                            </Text>
                        </Text>
                    </View>
                </TouchableOpacity>,
            );
        });
        return items;
    };

    return (
        <View style={{ flex: 1 }}>
            <ImageBackground
                source={getRecursURL(recursos, "background_default", idioma)}
                style={{ flex: 1, resizeMode: "cover" }}
            >
                {/* Box Perfil (NOM) */}
                <View
                    style={{ flex: 20, justifyContent: "center", alignItems: "center" }}
                >
                    <View
                        style={[
                            style.boxNom,
                            { backgroundColor: projecte.colorPrincipal2 },
                        ]}
                    >
                        <Text style={style.textPerfil}>
                            {getRecursText(recursos, "perfil_nom", idioma)}
                        </Text>
                        <Text style={style.nom}>{nom}</Text>
                    </View>
                </View>
                {/* Box Perfil (PUNTS) */}
                <View
                    style={{
                        flex: 15,
                        display: "flex",
                        flexWrap: "wrap",
                        flexDirection: "row",
                        justifyContent: "center",
                    }}
                >
                    <View
                        style={{ width: "40%", height: "90%", justifyContent: "center" }}
                    >
                        <View
                            style={{
                                alignSelf: "center",
                                backgroundColor: projecte.colorPrincipal2,
                                alignItems: "center",
                                justifyContent: "center",
                                width: "90%",
                                height: "100%",
                            }}
                        >
                            <Text style={style.SecondTitle}>
                                {getRecursText(recursos, "perfil_punts_totals", idioma)}
                            </Text>
                            <Text style={style.SecondText}>{punts}</Text>
                        </View>
                    </View>
                    <View
                        style={{ width: "40%", height: "90%", justifyContent: "center" }}
                    >
                        <View
                            style={{
                                alignSelf: "center",
                                width: "90%",
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: projecte.colorPrincipal2,
                            }}
                        >
                            <Text style={style.SecondTitle}>
                                {getRecursText(recursos, "perfil_punts_itineraris", idioma)}
                            </Text>
                            <Text style={style.SecondText}>
                                {statsItineraris.itinerarisFinalitzat}/{itineraris.length}
                            </Text>
                        </View>
                    </View>
                </View>

                {/* Itineraris */}
                <View
                    style={{
                        flex: 45,
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        flexDirection: "row",
                    }}
                >
                    <ScrollView style={style.caixa}>
                        <View
                            style={{
                                justifyContent: "center",
                                flexGrow: 0,
                                alignItems: "center",
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                            }}
                        >
                            {renderItineraris()}
                        </View>
                    </ScrollView>
                </View>

                {/* Compartir xarxes */}
                <View
                    style={{ flex: 10, justifyContent: "center", alignItems: "center" }}
                >
                    <View
                        style={{
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "row",
                        }}
                    >
                        {/*<TouchableOpacity*/}
                        {/*  style={{*/}
                        {/*    height:*/}
                        {/*      Dimensions.get("screen").height * (13 / 15) * 0.67 * 0.11,*/}
                        {/*    width:*/}
                        {/*      Dimensions.get("screen").height * (13 / 15) * 0.67 * 0.11,*/}
                        {/*  }}*/}
                        {/*  onPress={() => {*/}
                        {/*    RouterData.navigation.navigate(*/}
                        {/*      "Credits",*/}
                        {/*      RouterData.route.params,*/}
                        {/*    );*/}
                        {/*  }}*/}
                        {/*>*/}
                        {/*  <Image*/}
                        {/*    style={{*/}
                        {/*      width: "100%",*/}
                        {/*      height: "90%",*/}
                        {/*      alignSelf: "center",*/}
                        {/*      resizeMode: "contain",*/}
                        {/*    }}*/}
                        {/*    source={{*/}
                        {/*      uri: getRecursURL(recursos, "perfil_contacte", idioma),*/}
                        {/*    }}*/}
                        {/*  />*/}
                        {/*</TouchableOpacity>*/}
                        {XarxesSocials(RouterData, token, {
                            textSocial: encodeURI(projecte["textSocial" + idioma]).replaceAll(
                                "#",
                                "%23",
                            ),
                            peticio: "Global",
                        })}
                    </View>
                </View>
                {/* Menu */}
                <View style={{ flex: 10 }}>
                    <Menu projecte={RouterData.route.params}></Menu>
                </View>
            </ImageBackground>
        </View>
    );
}

export default Perfil;
